module.exports = __webpack_public_path__ + "f0cb00eb.png";